import validate from "/var/www/mov-dev.m2lab.ru/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/var/www/mov-dev.m2lab.ru/middleware/auth.global.ts";
import manifest_45route_45rule from "/var/www/mov-dev.m2lab.ru/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "can-view": () => import("/var/www/mov-dev.m2lab.ru/middleware/canView.ts")
}